import { api } from "@/utils/api";
import { sanitizePathParam } from "@/utils/sanitize";

export default class StateMachineRepository {
  async getAllStateMachines({
    name,
    locationId = null,
    inpId,
    page = 1,
    size = 20,
  }: {
    name: string | null;
    locationId?: string | number | null;
    inpId: string | null;
    page: number;
    size: number;
  }) {
    const response = await api.get(`/statemachine/`, {
      params: { name, locationId, inpId, page, size },
    });
    return response.data;
  }

  async createStateMachine({
    name,
    locationId,
    inpId,
    enabled = true,
  }: {
    name: string | null;
    locationId?: string | number | null;
    inpId: string | null;
    enabled: boolean;
  }) {
    const response = await api.post(`/statemachine/`, {
      name,
      locationId,
      inpId,
      enabled,
      nodes: "[]",
      edges: "[]",
      definition: "",
    });
    return response.data;
  }

  async editStateMachineComplete(data: any) {
    const response = await api.post(`/statemachine/`, data);
    return response.data;
  }

  async updateStateMachineStatus(machineId: string | number, enabled: boolean) {
    const mid = sanitizePathParam(machineId);
    const response = await api.put(`/statemachine/${mid}/status`, { enabled });
    return response.data;
  }

  async getStateMachineDetail(machineId: string | number) {
    const mid = sanitizePathParam(machineId);
    const response = await api.get(`/statemachine/${mid}`);
    return response.data;
  }
}
